import { DevelopmentHistoryTranslationDTO } from "../domain/models/dto/DevelopmentHistoryDTO";
import { IDevelopmentHistoryTranslation } from "../domain/models/DevelopmentHistoryTranslation";
import { SimpleMapper } from "./SimpleMapper";

export class DevelopmentHistoryTranslationMapper extends SimpleMapper<IDevelopmentHistoryTranslation, DevelopmentHistoryTranslationDTO> {
    protected toDTOFields: string[] = [
        "id",
        "developmentHistoryId",
        "languageCode",
        "title",
        "description",
        "stageDateTime",
        "imageUrl",
    ];
    protected fromDTOFields: string[] = [...this.toDTOFields, "creatorId", "createdAt", "updatedAt", "updatorId"];

}
